import { render, staticRenderFns } from "./Visionary.vue?vue&type=template&id=a2ba930a&"
import script from "./Visionary.vue?vue&type=script&lang=js&"
export * from "./Visionary.vue?vue&type=script&lang=js&"
import style0 from "./Visionary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
